module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/target01-14ac2793445a009c463b42123c72b278.png";